module.exports = __webpack_public_path__ + "img/icon1.e7e6b51b.svg";